// context/ReportIssueContext.tsx
import { createContext, useContext, useState } from "react";

const ReportIssueContext = createContext<any>(null);

export const ReportIssueProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [issue, setIssue] = useState("");
  
  const openReportModal = (defaultIssue = "") => {
    setIssue(defaultIssue);
    setIsModalOpen(true);
  };

  return (
    <ReportIssueContext.Provider value={{
      isModalOpen,
      setIsModalOpen,
      issue,
      setIssue,
      openReportModal
    }}>
      {children}
    </ReportIssueContext.Provider>
  );
};

export const useReportIssue = () => useContext(ReportIssueContext);
